/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * BBO Accounting Location Api
 * Accounting Location API defining how to get and modify Accounting Locations

REST APIs for Back Office stock count service. This service is specifically designed for stock functionality- stock count. Feature services are.<ul><li>Get Stock Count Type List</li></ul>

REST APIs for Back Office Forex Management Service. This service is specifically designed for forex functionality- forex counting, variance declaration, forex details, and etc. Feature services are.<ul><li>Branch Forex Overview</li><li>Fetch the Forex currencies</li></ul>

Provide Task Status and Uncompleted Task History
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  BboStockManagementBadRequestResponse,
  BboStockManagementFailureResponseResponse,
  BboStockManagementForbiddenResponse,
  BboStockManagementNoContentResponse,
  BboStockManagementUnauthorizedResponse,
  StockItem,
} from '../model';
import { customInstance } from '../mutator/customInstance';
import type { ErrorType } from '../mutator/customInstance';

/**
 * Get print list for count type
 * @summary this endpoint is used to details for print list
 */
export const getPrintListForCountType = (
  countType: string,
  accountingLocationID: string,
  signal?: AbortSignal,
) => {
  return customInstance<StockItem | BboStockManagementNoContentResponse>({
    url: `/bm-stock-management-service/v1/print-list/${countType}/${accountingLocationID}`,
    method: 'get',
    signal,
  });
};

export const getGetPrintListForCountTypeQueryKey = (
  countType: string,
  accountingLocationID: string,
) => {
  return [
    `/bm-stock-management-service/v1/print-list/${countType}/${accountingLocationID}`,
  ] as const;
};

export const getGetPrintListForCountTypeQueryOptions = <
  TData = Awaited<ReturnType<typeof getPrintListForCountType>>,
  TError = ErrorType<
    | BboStockManagementBadRequestResponse
    | BboStockManagementUnauthorizedResponse
    | BboStockManagementForbiddenResponse
    | BboStockManagementFailureResponseResponse
  >,
>(
  countType: string,
  accountingLocationID: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPrintListForCountType>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPrintListForCountTypeQueryKey(countType, accountingLocationID);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPrintListForCountType>>> = ({
    signal,
  }) => getPrintListForCountType(countType, accountingLocationID, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(countType && accountingLocationID),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getPrintListForCountType>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type GetPrintListForCountTypeQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPrintListForCountType>>
>;
export type GetPrintListForCountTypeQueryError = ErrorType<
  | BboStockManagementBadRequestResponse
  | BboStockManagementUnauthorizedResponse
  | BboStockManagementForbiddenResponse
  | BboStockManagementFailureResponseResponse
>;

/**
 * @summary this endpoint is used to details for print list
 */
export const useGetPrintListForCountType = <
  TData = Awaited<ReturnType<typeof getPrintListForCountType>>,
  TError = ErrorType<
    | BboStockManagementBadRequestResponse
    | BboStockManagementUnauthorizedResponse
    | BboStockManagementForbiddenResponse
    | BboStockManagementFailureResponseResponse
  >,
>(
  countType: string,
  accountingLocationID: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPrintListForCountType>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetPrintListForCountTypeQueryOptions(
    countType,
    accountingLocationID,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};
